import { graphql } from '@/gql/__generated__';

export const ME_QUERY = graphql(`
  query me {
    me {
      id
      name
      lastName
      email
      role {
        id
        name
      }
      phoneNumber
      profileUpdated
      emailVerified
      termsAccepted
      passwordSet
      limitedAccess
      identificationDocument {
        id
        type {
          id
          name
        }
      }
    }
  }
`);

export const PROFILE_QUERY = graphql(`
  query profile {
    me {
      id
      name
      lastName
      email
      phoneNumber
      passwordSet
      profileUpdated
      emailVerified
      subscribedToNewsletter
      limitedAccess
      identificationDocument {
        id
        type {
          id
          name
        }
      }
      properties {
        data {
          id
          label
          value
        }
      }
    }
  }
`);

export const AUTHENTICATE_WITH_THIRD_PARTY = graphql(`
  mutation authenticateWithThirdParty($input: AuthenticateWithThirdPartyInput!) {
    authenticateWithThirdParty(input: $input) {
      redirectTo
    }
  }
`);

export const FORGOTPASSWORD_MUTATION = graphql(`
  mutation forgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      message
    }
  }
`);

export const PRE_LOGIN_MUTATION = graphql(`
  mutation preLogin($input: PreLoginInput!) {
    preLogin(input: $input) {
      message
      canContinue
      code
      redirectTo
    }
  }
`);

export const SEND_VERIFICATION_LINK_MUTATION = graphql(`
  mutation sendAccountValidationMail($input: SendAccountValidationMailInput!) {
    sendAccountValidationMail(input: $input) {
      message
    }
  }
`);

export const UPDATE_PROPERTIES_MUTATION = graphql(`
  mutation setProfile($id: ID!, $properties: [SetProfileInput!]!) {
    setProfile(userId: $id, properties: $properties) {
      id
      properties {
        data {
          label
          value
        }
      }
    }
  }
`);

export const UPDATE_PROFILE_MUTATION = graphql(`
  mutation updateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      id
      name
      lastName
      email
      phoneNumber
      passwordSet
      termsAccepted
      profileUpdated
      emailVerified
      subscribedToNewsletter
      limitedAccess
      identificationDocument {
        id
        type {
          id
          name
        }
      }
      properties {
        data {
          id
          label
          value
        }
      }
    }
  }
`);

export const RESET_PASSWORD_MUTATION = graphql(`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      user {
        id
        passwordSet
        emailVerified
        profileUpdated
      }
    }
  }
`);

export const REGISTER_MUTATION = graphql(`
  mutation register($input: RegisterInput!) {
    register(input: $input) {
      user {
        id
        name
        email
        limitedAccess
        identificationDocument {
          id
          type {
            name
          }
        }
      }
    }
  }
`);

export const VALIDATE_ACCOUNT_MUTATION = graphql(`
  mutation exchangeAccountValidationCode($input: ExchangeAccountValidationCode!) {
    exchangeAccountValidationCode(input: $input) {
      email
    }
  }
`);

export const LOGIN_MUTATION = graphql(`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      user {
        id
        email
        name
        role {
          id
          name
        }
        lastName
        emailVerified
        profileUpdated
        termsAccepted
      }
    }
  }
`);

export const LOGOUT_MUTATION = graphql(`
  mutation logout {
    logout
  }
`);

export const EXCHANGE_VERIFICATION_CODE = graphql(`
  mutation exchangeVerificationCode($input: ExchangeAccountValidationCode!) {
    exchangeAccountValidationCode(input: $input) {
      id
      emailVerified
    }
  }
`);

export const LOGIN_WITH_DOCUMENT = graphql(`
  mutation loginWithDocument($input: LoginWithDocumentInput!) {
    loginWithDocument(input: $input) {
      user {
        id
        name
        lastName
        emailVerified
        opportunityCount
        identificationDocument {
          id
          type {
            id
            name
          }
        }
        termsAccepted
        profileUpdated
        limitedAccess
      }
    }
  }
`);

export const SEND_OTP = graphql(`
  mutation sendOTP($input: SendOTPInput!) {
    sendOTP(input: $input) {
      message
    }
  }
`);

export const VALIDATE_OTP = graphql(`
  mutation validateOTP($input: ValidateOTPInput!) {
    validateOTP(input: $input) {
      valid
      message
      user {
        id
        name
        lastName
        email
        role {
          id
          name
        }
        phoneNumber
        profileUpdated
        emailVerified
        termsAccepted
        passwordSet
        limitedAccess
        identificationDocument {
          id
          type {
            id
            name
          }
        }
      }
    }
  }
`);
